import { useQuery } from '@tanstack/react-query'

import { formatTreeResult } from './utils'
import { getQuickSearch } from '../../utils/search-service'
import { notifySentry } from '../../utils/sentry'

const injectDisplayCountsForFacets = (facets = []) => {
  facets?.forEach?.((facet) => {
    if (facet?.count >= 0 && Number.isInteger(facet.count)) facet.displayCount = facet.count?.toLocaleString?.()
    if (facet?.facets?.length) injectDisplayCountsForFacets(facet?.facets)
  })
}

export default function useTree({ search = {}, facets = {}, pagination = {}, saveSearch = false } = {}) {
  return useQuery({
    queryKey: ['tree-search', search, facets, pagination],
    queryFn: async () => {
      try {
        const extras = { includeMemoriesArtifacts: true }
        const resp = await getQuickSearch({
          type: 'tree',
          query: { ...search, ...facets, ...extras },
          pagination,
          saveSearch,
        })
        if (resp?.data?.treeStatus !== 'SUCCESS') throw new Error('No Tree Response Received.')
        injectDisplayCountsForFacets(resp?.data?.facets)

        return {
          count: resp.data.treesTotal,
          results: resp.data.results?.map((result) => formatTreeResult(result)),
          facets: resp.data.facets?.[0]?.facets,
        }
      } catch (error) {
        notifySentry({
          message: 'Failed to fetch tree search results',
          error,
          extraData: { search, facets, pagination, saveSearch },
        })
        throw error
      }
    },
    enabled: Boolean(search?.['q.surname']?.length),
    placeholderData: (prev) => prev,
  })
}
